package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InitialInspectionRequest(
    @SerialName("appointment_id")
    val appointmentId: String,
    @SerialName("inspection_option_id")
    val inspectionOptionId: Int? = null,
    @SerialName("inspection_type_id")
    val inspectionTypeId: Int,
    @SerialName("is_checked")
    val isChecked: Int,
    @SerialName("is_custom")
    val isCustom: Int = 0,
    val value: String? = null
)
